import React from 'react';
import { useFeatureValue } from '@growthbook/growthbook-react';

import { GB_FEATURES } from 'dpl/shared/constants/gb_features';
import { isMobileUA } from 'dpl/shared/utils';
import {
  PuppyCardPropTypes,
  PuppyCardPropDefaultTypes
} from 'dpl/shared/utils/customPropTypes';

import Card from './Card';
import CardV2 from './v2/Card';

const IS_MOBILE_UA = isMobileUA();

export default function PuppyCard({
  puppy,
  analytics,
  hideDistance,
  showPrice,
  className,
  style,
  trackInView,
  onClick,
  onFavoriteChange,
  view
}) {
  const variant = useFeatureValue(
    GB_FEATURES.EXP_PUPPY_CARD_REDESIGN_MOBILE,
    'control'
  );
  const CardComponent = IS_MOBILE_UA && variant === 'variant_1' ? CardV2 : Card;

  return (
    <CardComponent
      puppy={puppy}
      analytics={analytics}
      hideDistance={hideDistance}
      showPrice={showPrice}
      className={className}
      style={style}
      trackInView={trackInView}
      onClick={onClick}
      onFavoriteChange={onFavoriteChange}
      view={view}
    />
  );
}

PuppyCard.propTypes = PuppyCardPropTypes;
PuppyCard.defaultProps = PuppyCardPropDefaultTypes;
